export const ContentBase = 'https://pflau.com/public/visihint/';